import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragScrollExtendedComponent } from './drag-scroll.component';
import { DragScrollModule } from 'ngx-drag-scroll';

@NgModule({
  declarations: [DragScrollExtendedComponent],
  imports: [CommonModule, DragScrollModule],
  exports: [DragScrollExtendedComponent]
})
export class DragScrollExtendedModule {}
